import $ from 'jquery';
window.$ = window.jQuery = $;
import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Modal } from './modules/modal.js';
import { default as Nav } from './modules/nav.js';
import { default as Slider } from './modules/slider.js';
import { default as Work } from './modules/work.js';

const modules = {
  Common,
  Accordion,
  Collapse,
  Modal,
  Nav,
  Slider,
  Work,
};

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
